import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { useGSAP } from '@gsap/react'

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP)
    ScrollTrigger.config({ ignoreMobileResize: true })
}

export { gsap, ScrollTrigger, SplitText, useGSAP }

// Media conditions shared by every scroll composition. Desktop compositions
// (sticky, horizontal, cursor-led) only run when there is room and the visitor
// has not asked for reduced motion; everything else falls back to static layout.
export const MOTION_QUERIES = {
    motion: '(prefers-reduced-motion: no-preference)',
    desktop: '(min-width: 1024px) and (prefers-reduced-motion: no-preference)',
    fine: '(pointer: fine) and (prefers-reduced-motion: no-preference)'
} as const

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return true
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
